import React from "react";
import {
  LogIn,
  UserCog,
  FileText,
  CreditCard,
  Upload,
  CheckCircle2,
  CalendarDays,
  MessagesSquare,
  Eye,
  Zap,
  Activity as ActivityIcon,
} from "lucide-react";
import { formatDateTime } from "../../lib/api";

const TYPE_META = {
  login: { icon: LogIn, cls: "bg-blue-100 text-blue-600" },
  profile: { icon: UserCog, cls: "bg-gray-100 text-gray-600" },
  invoice: { icon: FileText, cls: "bg-navy/10 text-navy" },
  payment: { icon: CreditCard, cls: "bg-green-100 text-green-600" },
  document: { icon: Upload, cls: "bg-amber-100 text-amber-700" },
  document_review: { icon: CheckCircle2, cls: "bg-green-100 text-green-600" },
  appointment: { icon: CalendarDays, cls: "bg-purple-100 text-purple-600" },
  message: { icon: MessagesSquare, cls: "bg-gold/20 text-gold-dark" },
  impersonate: { icon: Eye, cls: "bg-red-100 text-red-600" },
  disputefox: { icon: Zap, cls: "bg-orange-100 text-orange-600" },
};

export function ActivityTimeline({ items, showWho = false, emptyText = "No activity yet." }) {
  if (!items || items.length === 0) {
    return (
      <div className="text-center py-10 text-gray-400" data-testid="activity-empty">
        <ActivityIcon className="h-9 w-9 mx-auto mb-2 opacity-50" />
        {emptyText}
      </div>
    );
  }
  return (
    <ol className="relative space-y-4" data-testid="activity-timeline">
      {items.map((e, i) => {
        const meta = TYPE_META[e.type] || { icon: ActivityIcon, cls: "bg-gray-100 text-gray-600" };
        const Icon = meta.icon;
        return (
          <li key={i} className="flex gap-3" data-testid={`activity-item-${i}`}>
            <div className={`h-9 w-9 rounded-full flex items-center justify-center flex-shrink-0 ${meta.cls}`}>
              <Icon className="h-4 w-4" />
            </div>
            <div className="min-w-0 flex-1 pb-1">
              <div className="text-sm text-navy font-medium leading-snug">
                {showWho && e.who ? <span className="text-gold-dark">{e.who} · </span> : null}
                {e.title}
              </div>
              {e.description ? (
                <div className="text-xs text-gray-500 truncate">{e.description}</div>
              ) : null}
              <div className="text-[11px] text-gray-400 mt-0.5">{formatDateTime(e.at)}</div>
            </div>
          </li>
        );
      })}
    </ol>
  );
}

export default ActivityTimeline;
